import { Center } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import { Text, Stack } from "@chakra-ui/react";
import { Box, Button } from "@chakra-ui/react";
import video from "../videos/video.mp4";
import logo from "../images/SafeCraft_logo.webp";

export default function Hero() {
  return (
    <Center
      className="video-background-container"
      h="95vh"
      color="white"
      id="hero"
    >
      <video
        className="background-video"
        src={video}
        autoPlay
        loop
        muted
        playsInline
        preload="none"
      />
      <Stack
        className="content-overlay"
        maxWidth="70%"
        align="center"
        justifyContent="center"
      >
        <Box maxWidth={{ base: "500px" }}>
          <img src={logo} alt="SafeCrafts logo" loading="lazy" />
        </Box>
        <Heading textAlign="center" as="h1" size={{ "2xl": "4xl", lg: "2xl" }}>
          Obuka iz oblasti sajber bezbednosti
        </Heading>
        <Text className="hero-text" fontSize="xl">
          POWERED BY DEVOPSCRAFTS
        </Text>
        <Button
          as="a"
          href="#contact"
          className="hero-btn"
          bg="#C9342D"
          color="white"
          variant="solid"
        >
          Kontaktirajte nas
        </Button>
      </Stack>
    </Center>
  );
}
